
//TODO: Eliminar fake data

const cobros = [
    {
        key: "conceptoDesc",
        label: "Item",
        sortable: true,
    },
    {
        key: "idContrato",
        label: "Nº de Contrato",
        sortable: true,
    },
    {
        key: "idReserva",
        label: "Nº de Reserva",
        sortable: true,
    },
    {
        key: "valorRecupRepto",
        label: "Monto",
        sortable: true,
    },
    {
        key: "idSucursal",
        label: "Sucursal",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    }
];

module.exports = {
    cobros
};
